module.exports = __webpack_public_path__ + "img/Nick-Ma.34004a7c.jpg";